import { z } from 'zod';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { isMongoId } from '../../helpers';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CalendarDay } from '../../../utils';

export const currencyRateOverridesSchema = z.record(
  z.nativeEnum(CurrencyCode),
  z.object({
    overrideRate: z.number().optional(),
    overrideSource: z.string().optional(),
  }),
);

export const GetUnrealisedCashFXGainsInput = z.object({
  currencyRateOverrides: currencyRateOverridesSchema.optional(),
  periodStart: z.instanceof(CalendarDay).optional(),
  periodEnd: z.instanceof(CalendarDay),
});

export const CreateUnrealisedCashFXGainOrLossInput = z.object({
  periodEnd: z.instanceof(CalendarDay),
  bankAccounts: z.array(
    z.object({
      bankAccountId: z.string().refine(isMongoId(), {
        message: 'Please provide a valid bank account ID',
      }),
      transactions: z.array(
        z.object({
          transactionTypeId: z.string().refine(isMongoId(), {
            message: 'Please provide a valid transaction type ID',
          }),
          operationType: z.nativeEnum(TransactionOperation),
        }),
      ),
    }),
  ),
  currencyRateOverrides: currencyRateOverridesSchema.optional(),
});
